// extracted by mini-css-extract-plugin
export default {"form":"gTsxc"};